import { ProjectType } from "../models/basic/template";
import { AbstractService } from "./abstract-service";
import { URLS } from "./app-urls";

export class NpiProjectTypeService extends AbstractService<ProjectType> {

    constructor() {
        super(URLS.NPI_PROJECT_TYPE);
    }
}
